import { Gamepad2 } from "lucide-react";
import { NavigationItem } from "./types";

/**
 * Labs — the light-bulb app in the strip. Home for prototypes that are not
 * part of a product area yet; Role Playing moved here from Learning Center
 * (2026-10-14).
 */
const navigation: NavigationItem[] = [
  {
    name: "Role Playing",
    href: "/games/door-to-done",
    icon: Gamepad2,
    current: false,
    internalName: "door_to_done_game",
  },
];

const labsConfig = {
  sectionName: "labs",
  defaultRoute: "/games/door-to-done",
  navigation,
};

export default labsConfig;
